// Replaces the offline-js vendor lib: fixed top banner shown while the browser
// is offline, driven by the native online/offline events. Text is fixed English
// for parity with the old offline-language-english.css pack.
function initialize() {
  if (typeof window === 'undefined' || window.__beebeeOfflineBanner) {
    return;
  }
  const el = document.createElement('div');
  el.className = 'bb-offline-banner';
  el.setAttribute('role', 'status');
  el.textContent = 'No internet connection.';
  document.body.appendChild(el);
  const update = () => {
    el.classList.toggle('is-visible', !navigator.onLine);
  };
  window.addEventListener('online', update);
  window.addEventListener('offline', update);
  update();

  // Guard against duplicate banners/listeners when multiple app instances boot
  // (tests, engines).
  window.__beebeeOfflineBanner = el;
}
var offlineBanner = {
  name: 'offline-banner',
  initialize
};

export { offlineBanner as default, initialize };
//# sourceMappingURL=offline-banner.js.map
